const INDEXES_DIFF = 1;
const EMPTY_VALUE = 0;

export const getIndexesUtil = (array: unknown[]): number => Math.max(array.length - INDEXES_DIFF, EMPTY_VALUE);

export default getIndexesUtil;
